module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Sending mail-f3354c1d44cc33f93ccd91ab165afded.svg";